import React, { useEffect, useState } from "react";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../_redux/adminDashboard/adminDashboardActions";
import UnmappedFilesTable from "../AdminDashboard/UnmappedFilesTable";
import { AdminDashboardUIProvider } from "./AdminDashboardUIContext";
import { UnknownEmailSenderUIProvider } from "./UnknownEmailSenderUiContext";
import UnknownEmailSenderTable from "./UnknownEmailSenderTable";
import { UnknownEmailSenderFilter } from "./UnknownEmailSenderFilter";
import { UnmappedFilesFilter } from "./UnmappedFilesFilter";

export default function AdminDashboard() {
  const { adminDashboard } = useSelector((state) => state, shallowEqual);

  const { newAccounts, totalAccounts } = adminDashboard;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchAccountsStatistics());
  }, []);

  return (
    <>
      <AdminDashboardUIProvider>
        <Card>
          <CardBody>
            new accounts in last 30 days {newAccounts} / {totalAccounts}
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <h1>Unmapped Files</h1>
            <UnmappedFilesFilter />
            <UnmappedFilesTable />
          </CardBody>
        </Card>
      </AdminDashboardUIProvider>
      <UnknownEmailSenderUIProvider>
        <Card>
          <CardBody>
            <h1>Unknown Email Sender</h1>
            <UnknownEmailSenderFilter />
            <UnknownEmailSenderTable />
          </CardBody>
        </Card>
      </UnknownEmailSenderUIProvider>
    </>
  );
}
